import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/(app)/about/page.jsx");
